import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translations
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import ptBRTranslations from './locales/pt-BR.json';
import ptTranslations from './locales/pt.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import itTranslations from './locales/it.json';
import nlTranslations from './locales/nl.json';
import plTranslations from './locales/pl.json';
import htTranslations from './locales/ht.json';
import zhTranslations from './locales/zh.json';
import koTranslations from './locales/ko.json';
import viTranslations from './locales/vi.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
      'pt-BR': { translation: ptBRTranslations },
      pt: { translation: ptTranslations },
      fr: { translation: frTranslations },
      de: { translation: deTranslations },
      it: { translation: itTranslations },
      nl: { translation: nlTranslations },
      pl: { translation: plTranslations },
      ht: { translation: htTranslations },
      zh: { translation: zhTranslations },
      ko: { translation: koTranslations },
      vi: { translation: viTranslations }
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
